import Image from 'next/legacy/image';

import { Container } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeCardStepNumberProps } from './types';

/**
 * CardStep
 */
export const CardStepNumber: FunctionComponent<TypeCardStepNumberProps> = ({
  className = '',
  image,
  number,
  description,
}: TypeCardStepNumberProps) => (
  <Container
    padding="px-0 py-0 sm:py-10 sm:px-8"
    className={`flex min-h-56 max-w-[396px] !flex-row flex-nowrap items-center gap-8 ${className}`}
  >
    {image && (
      <Image
        src={image.sourceUrl}
        width={120}
        height={120}
        alt={image.altText}
      />
    )}
    <div className="flex max-w-[188px] flex-grow flex-col items-start gap-y-2">
      {number && (
        <span className="u-display u-display--xl text-secondary-500">
          {number}
        </span>
      )}

      {description && (
        <span className="u-subtitle u-subtitle--l text-left uppercase text-primary-900">
          {description}
        </span>
      )}
    </div>
  </Container>
);
